<template>
    <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-900 to-black text-white p-4">
      <div class="w-full max-w-md bg-gray-800 bg-opacity-95 p-10 rounded-2xl shadow-xl flex items-center justify-center">
        <div class="text-center">
          <h2 class="text-4xl font-extrabold text-blue-400">Logging out...</h2>
          <p class="text-gray-300 mt-2">You will be redirected to the login page.</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios'; // Import the axios instance
  export default {
    name: "LogoutPage",
    mounted() {
      this.logout();
    },
    methods: {
      logout() {
        try {
        axios.post('https://api.syniac.com:3000/api/auth/api/logout', {}, { withCredentials: true });
        console.log("Logged out successfully");
        this.$router.push("/login");
    } catch (error) {
        console.error("Logout failed:", error);
    }
      },
    },
  };
  </script>
  
  <style scoped>
  /* You can add custom styles here if needed */
  </style>
  
